import { css } from 'styled-system/css';

export const menuBarStyle = {
	sportsMenu: css({
		_mars: {
			bgColor: 'sportsMenu.bg',
			borderBottom: '1px solid {colors.black.5}',
			'& .btn': {
				flexDirection: 'row',
				color: 'black.2',
				px: '3px',
			},
			'& .btn[data-active="true"]': {
				color: 'sportsMenu.buttonActive',
				_after: {
					content: '""',
					position: 'absolute',
					height: '2px',
					rounded: '2px 2px 0 0',
					left: '3px',
					right: '3px',
					bottom: 0,
					bgColor: 'sportsMenu.buttonActive',
				},
			},
			'& .icon--sport': {
				mr: '3px',
				mb: 0,
				width: '24px',
				height: '24px',
			},
		},
	}),
	sportsMenu_container: css({
		_mars: {
			py: 0,
			pl: '12px',
			pr: 0,
		},
	}),
};